var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('b-badge',[_vm._v(_vm._s(_vm.sum))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }